import { ReactNode } from 'react'
import Link from 'next/link'
import { Navbar } from './Navbar'

export function ShopLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50 dark:bg-neutral-950">
      <Navbar />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-neutral-100 dark:border-neutral-800 bg-white dark:bg-neutral-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-neutral-900 dark:bg-white flex items-center justify-center">
                <svg className="w-4 h-4 text-white dark:text-neutral-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                </svg>
              </div>
              <span className="font-semibold text-neutral-900 dark:text-white">Butiken</span>
            </div>
            <nav className="flex items-center gap-6 text-sm text-neutral-500 dark:text-neutral-400">
              <Link href="/" className="hover:text-neutral-900 dark:hover:text-white">Hem</Link>
              <Link href="/search" className="hover:text-neutral-900 dark:hover:text-white">Sök</Link>
              <Link href="/cart" className="hover:text-neutral-900 dark:hover:text-white">Kundvagn</Link>
              <Link href="/orders" className="hover:text-neutral-900 dark:hover:text-white">Mina order</Link>
            </nav>
            <p className="text-xs text-neutral-400">
              © {new Date().getFullYear()} Butiken. Alla rättigheter förbehållna.
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}
